import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Sidebar from "../components/Sidebar";
import DashboardCourseCard from "../components/DashboardCourseCard";

const FILTERS = [
  { value: "all", label: "All" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
];

export default function MyCourses() {
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/dashboard/me")
      .then(r => setData(r.data))
      .catch(e => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  // Phase 14.5 defensive filter — never render disabled or coming-soon courses,
  // regardless of what the API returns. Belt-and-suspenders for content governance.
  const isVisible = (c) => c?.is_published !== false && !c?.is_coming_soon;
  const all = (data?.my_courses || []).filter(isVisible);
  const filtered = all.filter(c => {
    if (filter === "in_progress") return c.progress_percent > 0 && c.progress_percent < 100;
    if (filter === "completed") return c.progress_percent === 100;
    return true;
  });
  const recommended = (data?.recommended_courses || []).filter(isVisible);
  const locked = (data?.locked_courses || []).filter(isVisible);

  return (
    <div className="min-h-screen bg-fc-navy flex" data-surface="light" data-testid="my-courses-page">
      <Sidebar />
      <main className="flex-1 min-w-0 bg-[#F8F9FB] text-gray-900">
        <div className="h-20 px-6 lg:px-10 flex items-center justify-between border-b border-gray-200 bg-white/70 backdrop-blur sticky top-0 z-30">
          <div>
            <p className="fc-overline text-[10px]">MY COURSES</p>
            <h1 className="text-lg sm:text-xl font-black tracking-tight">Your learning library</h1>
          </div>
        </div>

        <div className="px-6 lg:px-10 py-8 space-y-12">
          {loading ? <p className="text-gray-500">Loading…</p> : (
            <>
              <section>
                <div className="flex flex-wrap gap-2 mb-6">
                  {FILTERS.map(f => (
                    <button
                      key={f.value}
                      onClick={() => setFilter(f.value)}
                      className={`px-3 py-1.5 text-[10px] tracking-[0.18em] font-bold uppercase rounded-full border ${filter===f.value ? "border-fc-red bg-fc-red text-white" : "border-gray-200 text-gray-500 hover:border-gray-300"}`}
                      data-testid={`mc-filter-${f.value}`}
                    >
                      {f.label}
                    </button>
                  ))}
                </div>
                {filtered.length === 0 ? (
                  <p className="text-gray-500 text-sm">No courses match this filter.</p>
                ) : (
                  <div className="grid gap-5" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))" }}>
                    {filtered.map(c => <DashboardCourseCard key={c.id} course={c} />)}
                  </div>
                )}
              </section>

              {recommended.length > 0 && (
                <section>
                  <h2 className="fc-h-section text-2xl mb-6">Recommended</h2>
                  <div className="grid gap-5" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))" }}>
                    {recommended.map(c => <DashboardCourseCard key={c.id} course={c} />)}
                  </div>
                </section>
              )}

              {locked.length > 0 && (
                <section>
                  <h2 className="fc-h-section text-2xl mb-6">Locked · Upgrade to Executive</h2>
                  <div className="grid gap-5" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))" }}>
                    {locked.map(c => <DashboardCourseCard key={c.id} course={c} locked />)}
                  </div>
                </section>
              )}
            </>
          )}
        </div>
      </main>
    </div>
  );
}
